import React from "react";
import Layout from "../components/Layout/Layout";
import "../styles/breadcrumb.css";


const Breadcrumb = () => {
  return (
    <nav className="breadcrumb-container">
      <ul className="breadcrumb">
        <li><a href="/">Home</a></li>
        <li><a href="/releases">Release</a></li>
        <li className="active">Release Notes 0.1</li>
      </ul>
    </nav>
  );
};

// Function component for the Release Notes page
const ReleaseNotes = () => {
  return (
    <Layout>
      
      <div className="release-notes-container">
        <Breadcrumb />
        <header className="release-header" >
          <h1 className="marginBottom10px">Release Notes</h1>
          <h2>Finkoda Web Application v0.1</h2>
          <p><strong>Release Date:</strong> February 15, 2025</p>
        </header>

        <section className="overview-section">
          <h3 className="overview">Overview</h3>
          <p>
            Finkoda is a next-generation personal finance and asset management
            platform, designed to empower users with secure, scalable, and user-friendly
            tools to manage their financial portfolios efficiently. This initial release
            lays a strong foundation with essential features that help users organize financial
            data, enhance security, and gain actionable insights through an intuitive interface.
          </p>
        </section>

        <section className="features-section">
          <h3>Features</h3>
          <ul className="custom-list">
            <li >
              <strong>Comprehensive Financial Management</strong>
              <p className="marginTop5px">A unified and secure repository to store and categorize various financial and asset-related information, including:</p>
              <ul className="custom-list">
                <li>Personal Records: Personal information, General information, contact details, and record documents</li>
                <li>Investments: Mutual funds, trading accounts, stocks, bonds, gold, and fixed deposits</li>
                <li>Banking: Bank accounts, card details, loans, PPF, NPS, and pension funds</li>
                <li>Insurance: Life, health, and general insurance policies</li>
                <li>Assets: Property, vehicles, and other physical or digital assets</li>
              </ul>
            </li>
            <li>
              <strong>Financial Health & Wealth Meter</strong>
              <p className="marginTop5px">A dynamic dashboard providing real-time insights into net worth and investment performance through a visually engaging Financial Health & Wealth Meter.</p>
            </li>
            <li>
              <strong>Enhanced Security Framework</strong>
              <ul className="custom-list">
                <li>Two-Factor Authentication (2FA): Secure login and registration via OTP verification</li>
                <li>Military-Grade Encryption:
                  <ul className="custom-list">
                    <li>AES-256 Encryption: Applied to all financial data, including banking and card details</li>
                    <li>Field-Level Encryption: Sensitive information, such as policy numbers and account IDs, is encrypted at rest and in transit</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </section>

        <section className="improvements-section">
          <h3>Improvements</h3>
          <ul className="custom-list">
            <li><strong>Performance Optimizations</strong> - Faster data retrieval and improved dashboard load times for a seamless user experience.</li>
            <li><strong>UI/UX Enhancements</strong>
              <ul className="custom-list">
                <li>Streamlined navigation menus for a more intuitive interface</li>
                <li>Improved form validations for better accuracy</li>
                <li>Responsive design enhancements for optimal cross-device compatibility</li>
              </ul>
            </li>
            <li><strong>Scalability Upgrades</strong> - Strengthened backend infrastructure to support future feature expansions and ensure system reliability</li>
          </ul>
        </section>

        <section className="known-issues-section">
          <h3 className="marginBottom10px">Known Issues</h3>
          <p>Network Latency: Users may experience occasional delays in data synchronization due to ongoing network optimizations. Our engineering team is actively working on solutions in upcoming updates.</p>
        </section>

        <section className="important-notes-section">
          <h3>Important Notes</h3>
          <ul className="custom-list">
            <li><strong>Data Backup Advisory</strong> - We strongly recommend backing up your financial data before making any updates to avoid accidental data loss</li>
            <li><strong>Feedback & Support</strong> - Your feedback is invaluable to us! If you encounter any issues or have suggestions, please reach out to us at <a href="mailto:contact@finkoda.com">contact@finkoda.com</a>.</li>
          </ul>
        </section>

        <footer className="release-footer">
          <p>Thank you for choosing Finkoda as your trusted financial partner!</p>
        </footer>
      </div>
    </Layout>
  );
};

export default ReleaseNotes;
